module.exports = __webpack_public_path__ + "static/biennale-light-it-5c0483dcb6ad8e54012a093ee6ce093b.otf";